import { store } from "@/_store";
import { UserService } from "../_services/api/settings/user/user.service";
import router from "../router";
import ApiService from "../_services/api/api.service";
import { CommonStorage, TokenStorage } from "../_services/storage";

const user = JSON.parse(localStorage.getItem("user"));
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: {}, user: null };

export const authentication = {
  namespaced: true,
  state: initialState,
  actions: {
    async login({ dispatch, commit }, { username, password }) {
      commit("loginRequest", { username });
      CommonStorage.saveItems('APP_SESSION_TIME_OUT', false);

      UserService.login(username, password).then(
        async () => {
          commit("loginSuccess", UserService.getUsername());
          store.dispatch("reportPdfPreview/setReportPreviewScreens");

          // Update access log
          ApiService.post("api/ApplicationTenantAccessLog", {
            ApplicationTenantCode: TokenStorage.getTenant(),
            ApplicationUserCode: TokenStorage.getTenantUserCode(),
            SessionId: TokenStorage.getToken(),
            DateIn: new Date(),
          })

          const queryString = window.location.search;
          const urlParams = new URLSearchParams(queryString);
          const redirect = urlParams.get('redirect');

          const broadcastChannel = new BroadcastChannel("session-channel");

          if (redirect) {
            await store.dispatch("globalFields/getGlobalFields");
            router.push({ path: redirect }).then(() => {
              broadcastChannel.postMessage({
                action: "login_success",
              });
            })
          }
          else {
            router.push("home").then(() => {
              broadcastChannel.postMessage({
                action: "login_success",
              });
            });
            store.dispatch("globalFields/getGlobalFields");
          }

        },
        (error) => {
          commit("loginFailure", error);

          dispatch("alert/error", "Invalid Username or Password", {
            root: true,
          });
        }
      );
    },
    logout({ commit }) {
      ApiService.post(
        "api/ApplicationTenantAccessLog",
        {
          ApplicationTenantCode: TokenStorage.getTenant(),
          ApplicationUserCode: TokenStorage.getTenantUserCode(),
          SessionId: TokenStorage.getToken(),
          DateOut: new Date(),
        },).catch((err) => {
          // this.$logger.debug(err);
          // eslint-disable-next-line no-console
          console.log("Logout TenantAccessLog Failed ", err);
        })
      UserService.logout();
      const prefetchLinks = document.querySelectorAll('link[rel="prefetch"]');
      const timestamp = new Date().getTime();
      prefetchLinks.forEach(link => {
        // Add 'noprefetch' attribute to disable prefetching
        link.setAttribute('noprefetch', '');
        link.href += `?v=${timestamp}`;
      });

      commit("logout");
    },
  },
  mutations: {
    loginRequest(state, user) {
      state.status = { loggingIn: true };
      state.user = user;
    },
    loginSuccess(state, user) {
      state.status = { loggedIn: true };
      state.user = user;
    },
    loginFailure(state) {
      state.status = {};
      state.user = null;
    },
    logout(state) {
      state.status = {};
      state.user = null;
      location.reload();
    },
  },
  getters: {
    currentUser(state) {
      return state.user ? state.user : UserService.getUsername();
    },
  },
};
